export const CLASSES = ['9', '11'] as const;
export const CLASS_NAMES: Record<string, string> = {
  '9': 'Class IX',
  '11': 'Class XI',
};

export function computeLevel(avg: number): string {
  if (avg >= 85) return 'Excellent';
  if (avg >= 70) return 'Good';
  if (avg >= 55) return 'Average';
  return 'Below Average';
}
